// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"20":"MiniAppMain","308":"DirectorMain","333":"Layout","754":"HeadTeacherMain","872":"TeacherMain"}[chunkId] || chunkId) + "." + {"20":"08e00fb9","59":"e64c9e0d","162":"d7e251d9","308":"bd4b1fc6","333":"24947ac7","754":"556daf3e","872":"53767a1c"}[chunkId] + ".js";
};